// src/models/landing-page.js
import membergroupservice from '@/services/membergroupservice';
import {responseAdapter as contactPersonResponseAdapter} from '@/models/contactperson'
import {responseAdapter as bankdataResponseAdapter} from '@/models/bankdata'

// The LandingPage class returns a clean
// LandingPage object with only the data we need.
export class MemberGroup {
  constructor({
    id = null,
    members = [],
    bankdata = null,
    contactPerson = null, 
    comment = '',
    status = '',
    family = null,
    links = []
  } = {}) {
    this.id = id
    this.members = members
    this.bankdata = bankdata
    this.contactPerson = contactPerson
    this.comment = comment
    this.status = status
    this.family = family
    this.links = links
  }
}

// We use an adapter to bring the API response
// from the Contentful API into the correct format
// for our LandingPage class.
//export function responseAdapter({ fields, sys }) {
//  return new Event({ ...fields, ...sys });
//}

export function responseAdapter(response) {

  let out = [];
  if(response == null){
    return out; 
  }
  else if (response.data != null && Array.isArray(response.data.content)) {
    response.data.content.forEach(element => {
      mapAndAdd(out, element)
    });
  }else if(response.data != null){
    mapAndAdd(out, response.data);
    return out[0];
  }else if(response != null){
    mapAndAdd(out, response);
    return out[0];
  }
  return out;
}

function mapAndAdd(out, element){
  let contactPerson = contactPersonResponseAdapter(element.contactPerson);
  let bankdata = bankdataResponseAdapter(element.bankdata);
  out.push(new MemberGroup({ ...element, contactPerson, bankdata }));
}

// We wrap the Contentful API client to format
// the response exactly the way we like it.
export default {
  async getAll() {
    return responseAdapter(await membergroupservice.getAll());
  },
  async get(memberGroupId) {
    return responseAdapter(await membergroupservice.get(memberGroupId));
  },
  async create(memberGroup) {
    return responseAdapter(await membergroupservice.create(memberGroup));
  },
  async createMember(memberGroupId, member) {
    return responseAdapter(await membergroupservice.createMember(memberGroupId, member));
  },
  async update(memberGroupId, memberGroup) {
    return responseAdapter(await membergroupservice.update(memberGroupId, memberGroup));
  },
  async updateStatus(url) {
    return responseAdapter(await membergroupservice.updateStatus(url));
  },
  async split(memberGroupId, input) {
    return responseAdapter(await membergroupservice.split(memberGroupId, input));
  },
};
